import { Map, fromJS } from 'immutable';
import { twinControlReducer } from '../multibirth/reducer.jsx';
import { rangeIter } from '../../../common/utils.jsx';

export const INIT_PERSONS_ARRAY = 'app/persons.array/INIT_PERSONS_ARRAY';
export const SUBMIT_PERSONS_ARRAY = 'app/persons.array/SUBMIT_PERSONS_ARRAY';
export const CHANGE_PERSONS_ARRAY = 'app/fields/CHANGE_PERSONS_ARRAY';
export const REMOVE_PERSON_FROM_ARRAY = 'app/fields/REMOVE_PERSON_FROM_ARRAY';
export function initPersonsArray(name) {
    return {
        type: INIT_PERSONS_ARRAY,
        name
    };
}

export function submitPersonsArray(name) {
    return {
        type: SUBMIT_PERSONS_ARRAY,
        name
    };
}


export function changePersonsArray(name, gender, difference) {
    return {
        type: CHANGE_PERSONS_ARRAY,
        name, gender, difference
    };
}

export function removePersonFromArray(name, id) {
    return {
        type: REMOVE_PERSON_FROM_ARRAY,
        id
    };
}

function _compareNumbers(leftValue, rightValue) { return leftValue - rightValue; }

export function personsArrayUpdateReducer(state, action) {
    const { gender, difference } = action;
    if (0 === difference || 50 === state.size) { return state; }
    let keys;
    const absDiff = Math.abs(difference);
    if (0 < difference) {
        keys = Object.keys(state.toJS()).sort(_compareNumbers);
        const newKey = keys.length ? parseInt(keys.pop()) + 1 : 1;
        return state.withMutations((persons) => rangeIter(0, absDiff, (key) =>
                    persons.set(String(newKey + key), new Map({ gender }))
            )
        );
    }
    const personsArrayByGender = state.filter((person) => gender === person.get('gender'));
    keys = Object.keys(personsArrayByGender.toJS()).sort(_compareNumbers);
    const keysForRemove = keys.slice(-absDiff);
    return state.filter((person, key) => -1 === keysForRemove.indexOf(String(key)));
}

export const PERSONS_ARRAY_ACTIONS = [
    INIT_PERSONS_ARRAY,
    SUBMIT_PERSONS_ARRAY,
    CHANGE_PERSONS_ARRAY,
    REMOVE_PERSON_FROM_ARRAY
];
export default function personsArrayReducer(state, action) {
    const name = action.name;
    switch (action.type) {
        case INIT_PERSONS_ARRAY:
            return state.set(name, fromJS({ submit: false, data: {}, multibirth: [] }));
        case SUBMIT_PERSONS_ARRAY:
            return state.setIn([ name, 'submit' ], true);
        case CHANGE_PERSONS_ARRAY:
            return twinControlReducer(state, action)
                .setIn([ name, 'data' ], personsArrayUpdateReducer(state.getIn([ name, 'data' ]), action));
        case REMOVE_PERSON_FROM_ARRAY:
            return state.deleteIn([ action.name, 'data', action.id ]);
        default:
            return state;
    }
}
